const BaseComponentPropKeysArray = [
    'name',
    'id',
    'data-testid',
    'tabIndex',
    'className',
    'style',
];

export { BaseComponentPropKeysArray };
//# sourceMappingURL=baseComponentProps.js.map
